export default "__VITE_ASSET__ClIIzNoD__"